(function () {
  var cache = {};
  function norm(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
  }
  function find(items, value) {
    var key = norm(value);
    return (items || []).find(function (item) { return norm(item.name || item) === key; }) || null;
  }
  function load(url) {
    if (!cache[url]) {
      cache[url] = fetch(url).then(function (response) {
        if (!response.ok) throw new Error('No se pudo cargar la lista de ubicaciones.');
        return response.json();
      });
    }
    return cache[url];
  }
  function mount(input, getItems, onSelect, onType) {
    if (input.dataset.pcComboReady) return;
    input.dataset.pcComboReady = 'true';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    var wrap = document.createElement('span');
    wrap.className = 'pc-cart__geo-combo';
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);
    var list = document.createElement('span');
    list.className = 'pc-cart__geo-options';
    list.hidden = true;
    wrap.appendChild(list);
    var active = -1;
    var selecting = false;
    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }
    function choose(value) {
      input.value = value;
      input.dataset.pcGeoValid = 'true';
      input.classList.remove('is-invalid');
      close();
      onSelect(value);
      selecting = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      selecting = false;
    }
    function draw() {
      var query = norm(input.value);
      var items = getItems();
      list.innerHTML = '';
      items.filter(function (item) {
        return !query || norm(item.name || item).indexOf(query) !== -1;
      }).slice(0, 60).forEach(function (item) {
        var value = item.name || item;
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = value;
        button.addEventListener('mousedown', function (event) {
          event.preventDefault();
          choose(value);
        });
        list.appendChild(button);
      });
      if (!list.children.length) {
        var empty = document.createElement('span');
        empty.className = 'pc-cart__geo-empty';
        empty.textContent = 'No se encontraron opciones';
        list.appendChild(empty);
      }
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }
    input.addEventListener('focus', draw);
    input.addEventListener('click', draw);
    input.addEventListener('input', function () {
      if (selecting) return;
      input.dataset.pcGeoValid = find(getItems(), input.value) ? 'true' : 'false';
      if (onType) onType(input.value);
      draw();
    });
    input.addEventListener('blur', function () {
      window.setTimeout(close, 120);
    });
    input.addEventListener('keydown', function (event) {
      var options = list.querySelectorAll('button');
      if (event.key === 'Escape') return close();
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (list.hidden) draw();
        options = list.querySelectorAll('button');
        if (!options.length) return;
        active = event.key === 'ArrowDown'
          ? Math.min(active + 1, options.length - 1)
          : Math.max(active - 1, 0);
        options.forEach(function (option, index) {
          option.classList.toggle('is-active', index === active);
        });
        options[active].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && !list.hidden && options.length) {
        event.preventDefault();
        choose(options[Math.max(active, 0)].textContent);
      }
    });
    input._pcGeoRefresh = function () {
      input.dataset.pcGeoValid = find(getItems(), input.value) ? 'true' : 'false';
    };
  }
  function mountAgency(select) {
    if (!select || select.dataset.pcAgencyReady) return;
    select.dataset.pcAgencyReady = 'true';
    var input = document.createElement('input');
    input.type = 'search';
    input.placeholder = 'Escribe para buscar una agencia';
    input.setAttribute('aria-label', 'Buscar agencia Shalom');
    select.parentNode.insertBefore(input, select);
    select.hidden = true;
    select.tabIndex = -1;
    select._pcAgencyInput = input;
    function items() {
      return Array.prototype.slice.call(select.options)
        .filter(function (option) { return option.value; })
        .map(function (option) { return option.value; });
    }
    function sync() {
      if (select.value) input.value = select.value;
      input.dataset.pcGeoValid = select.value ? 'true' : 'false';
    }
    mount(input, items, function (value) {
      select.value = value;
      select.classList.remove('is-invalid');
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }, function (value) {
      var match = find(items(), value);
      select.value = match || '';
      select.dispatchEvent(new Event('input', { bubbles: true }));
    });
    select.addEventListener('change', sync);
    new MutationObserver(sync).observe(select, { childList: true });
    select._pcAgencyRefresh = sync;
    sync();
  }
  function initialize(root) {
    if (!root || root.dataset.pcGeoLoading) return;
    root.querySelectorAll('[data-pc-agency-list]').forEach(mountAgency);
    var url = root.dataset.pcUbigeoUrl;
    if (!url) return;
    root.dataset.pcGeoLoading = 'true';
    load(url).then(function (data) {
      root.querySelectorAll('[data-pc-method-panel]').forEach(function (panel) {
        if (panel.dataset.pcGeoReady) return;
        panel.dataset.pcGeoReady = 'true';
        var department = panel.querySelector('[data-pc-field="Departamento"]');
        var province = panel.querySelector('[data-pc-field="Provincia"]');
        var district = panel.querySelector('[data-pc-field="Distrito"]');
        if (!department || !province || !district) return;
        function departments() { return data.departments || []; }
        function selectedDepartment() { return find(departments(), department.value); }
        function provinces() {
          var item = selectedDepartment();
          return item ? item.provinces : [];
        }
        function selectedProvince() { return find(provinces(), province.value); }
        function districts() {
          var item = selectedProvince();
          return item ? item.districts : [];
        }
        mount(department, departments, function () {
          province.value = '';
          district.value = '';
          province.disabled = false;
          district.disabled = true;
          province.dataset.pcGeoValid = 'false';
          district.dataset.pcGeoValid = 'false';
        });
        mount(province, provinces, function () {
          district.value = '';
          district.disabled = false;
          district.dataset.pcGeoValid = 'false';
        });
        mount(district, districts, function () {});
        function refresh() {
          department._pcGeoRefresh();
          province.disabled = !selectedDepartment();
          province._pcGeoRefresh();
          district.disabled = !selectedProvince();
          district._pcGeoRefresh();
        }
        panel._pcGeoRefresh = refresh;
        refresh();
      });
    }).catch(function (error) {
      console.error(error);
      root.dataset.pcGeoError = 'true';
    });
  }
  window.PCGeo = {
    init: initialize,
    refresh: function (root) {
      initialize(root);
      if (!root) return;
      root.querySelectorAll('[data-pc-method-panel]').forEach(function (panel) {
        if (panel._pcGeoRefresh) panel._pcGeoRefresh();
      });
      root.querySelectorAll('[data-pc-agency-list]').forEach(function (select) {
        mountAgency(select);
        if (select._pcAgencyRefresh) select._pcAgencyRefresh();
      });
    },
  };
  function scan() {
    document.querySelectorAll('[data-pc-agency-list]').forEach(mountAgency);
    document.querySelectorAll('[data-pc-ubigeo-url]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
}());